import { SearchMultiSelect } from './SearchMultiSelect'
import { withErrorCode } from '@/lib/errors'
import type { CompanyMemberDocument, ChoreographerRef } from '@/types'

interface Props {
  label: string
  members: Array<CompanyMemberDocument & { id: string }>
  selected: ChoreographerRef[]
  onChange: (updated: ChoreographerRef[]) => void
}

export function MemberSearchPicker({ label, members, selected, onChange }: Props) {
  const slugless = members.filter((m) => !m.slug)
  const seen = new Set<string>()
  const items = members
    .filter((m) => {
      if (!m.slug) return false
      if (seen.has(m.slug)) return false
      seen.add(m.slug)
      return true
    })
    .map((m) => ({
      id: m.slug,
      label: m.name,
      avatarUrl: m.squarePhotoUrl ?? m.photoUrl ?? '',
    }))

  const selectedIds = selected.map((s) => s.slug)

  function handleChange(ids: string[]) {
    const refs: ChoreographerRef[] = ids.map((id) => {
      const existing = selected.find((s) => s.slug === id)
      if (existing) return existing
      const m = members.find((mem) => mem.slug === id)
      return { name: m?.name ?? id, slug: id, photoUrl: m?.squarePhotoUrl ?? m?.photoUrl ?? '' }
    })
    onChange(refs)
  }

  return (
    <div className="space-y-1">
      <SearchMultiSelect
        label={label}
        items={items}
        selected={selectedIds}
        onChange={handleChange}
      />
      {slugless.length > 0 && (
        <p className="text-xs text-amber-600">
          {withErrorCode(
            `${slugless.length} member${slugless.length > 1 ? 's are' : ' is'} missing a slug and won't appear here: ${slugless.map((m) => m.name).join(', ')}. Edit their member profile to fix this.`,
            'company/member-slug-missing',
          )}
        </p>
      )}
    </div>
  )
}
